import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const AllCustomersTab: React.FC = () => (
  <LookerEmbedTab
    path="dashboards/99"
    height={1550}
    translationKey="reports.customer.tabs.all_customers"
  />
)

export default AllCustomersTab
